export default "__VITE_ASSET__BBGRxIlB__"